import { render } from "./BaseSwiper.vue?vue&type=template&id=390671db"
import script from "./BaseSwiper.vue?vue&type=script&lang=js"
export * from "./BaseSwiper.vue?vue&type=script&lang=js"

import "./BaseSwiper.vue?vue&type=style&index=0&id=390671db&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__